<template>
    <car-card :bid="bid"></car-card>
</template>

<script>
    import carCard from './../Card/BidLayout.vue'
    import apiAuth from './../../api/apiAuth'
    export default {
        props: ['bid'],
        components: {
            carCard: carCard,
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Bids/BidBox.vue